<template>
  <div class="container">
    <div class="wrap">
      <div class="l"></div>
      <div class="c">
        <div
          class="item"
          @click="goPath(item.pathName, index)"
          :class="{ 'item-a': $route.fullPath.indexOf(item.pathName) == 1 }"
          v-for="(item, index) in navList"
          :key="index"
        >
          {{ item.name }}
          <div
            class="line"
            v-if="$route.fullPath.indexOf(item.pathName) == 1"
          ></div>
        </div>
      </div>
      <div class="r">
        <div class="item login-text" v-if="showUser==false" @click="openLoginDia">
          登录/注册
        </div>
        <div class="right-menu" v-if="showUser == true">
            <el-dropdown class="avatar-container" trigger="hover">
              <div class="avatar-wrapper">
                <img
                  :src="userHeadimg ? userHeadimg : ''"
                  class="user-avatar"
                  style="width:40px;height:40px;"
                />
                <!-- <i class="el-icon-caret-bottom" /> -->
              </div>
              <el-dropdown-menu slot="dropdown" class="user-dropdown">
                <router-link to="/personalData">
                  <el-dropdown-item>个人资料</el-dropdown-item>
                </router-link>
                <router-link to="/accountSecurity">
                  <el-dropdown-item>账号安全</el-dropdown-item>
                </router-link>
                <el-dropdown-item divided @click.native="logout">
                  <span style="display: block">退出账号</span>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ts-nocheck
import Cookies from "js-cookie";
import { reqPersonalData } from "@/api/buTie.js"
import { loginout } from "@/api/login.js";
import "@/styles/common.css";
export default {
  data() {
    return {
      navList: [
        // {
        //   name: "选品池",
        //   pathName: "goodsAll",
        // },
        {
          name: "我的工作台",
          pathName: "workTable",
        }
      ],
      userInfo: {},
      userInfoJ: "",
      showUser: false,
      userHeadimg:'', // 用户toux
    };
  },
  mounted() {
    this.reqPersonalData()
    if (Cookies.get("token") && Cookies.get("userInfo")) {
      this.userSign = Cookies.get("token");
      this.userInfoJ = Cookies.get("userInfo");

      if (this.userSign && this.userInfoJ) {
        this.userInfo = JSON.parse(this.userInfoJ);
        if(this.userInfo.id=='1'){
          this.navList = [
            {
              name: "我的工作台",
              pathName: "workTable",
            }
          ]
        }else if(this.userInfo.id=='96'){
          this.navList = [
            {
              name: "我的工作台",
              pathName: "workTable",
            },
            {
              name: "管理团队",
              pathName: "management",
            },
          ]
        }
        this.showUser = true;
      } else {
        this.showUser = false;
      }
    }
  },
  methods: {
    // 获取用户头像
    reqPersonalData(){
      reqPersonalData({}).then(res=>{
        if(res.code==800){
          this.userHeadimg=res.data.headimgurl
        }
      })
    },
    //点击登录注册按钮
    openLoginDia() {
      this.$loginDialog.open();
    },
    goPath(pathName, index) {
      this.navActive = index;
      /**
       * 解决重复点击相同路由控制台报错 random随机数
       */
      this.$router.push({
        name: (this.userInfo.id == '96' && pathName == 'workTable') ? "myPeople" : pathName,
        query: { random: Math.random() }
      });
    },
    //退出登录
    logout() {
      loginout().then((res) => {
        this.showUser = false;
        if (res.code == 800) {
          Cookies.remove("token");
          Cookies.remove("userInfo");
          this.$message({
            message: "退出成功",
            type: "success",
          });
          window.location.reload();
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
// 
/deep/a{
  text-decoration:none;
}
/deep/.el-dropdown-link {
  cursor: pointer;
  color: #ff7919;
}
/deep/.el-icon-arrow-down {
  font-size: 12px;
}
.container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
}
.wrap {
  height: 56px;
  background: #fefefe;
  box-shadow: 0px 3px 9px 0px rgba(182, 182, 182, 0.21);
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  top: 0;
  left: 0;
  cursor: pointer;
}
.l {
  width: 202px;
  height: 56px;
}
.c {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  .item {
    height: 56px;
    font-size: 16px;
    color: #45474d;
    line-height: 56px;
    position: relative;
    margin: 0 25px;
  }
  .item-a {
    color: #fe2c55;
  }
  .line {
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 50px;
    height: 3px;
    background: #fe2c55;
  }
}
.r {
  margin-right: 68px;
  .item {
    width: 84px;
    height: 22px;
    background: #fefefe;
    border: 1px solid #fe2c55;
    border-radius: 11px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 12px;
    color: #fe2c55;
  }
  /deep/.login-text {
    display: inline-block;
    width: 84px;
    height: 22px;
    border: 1px solid #ff7919;
    border-radius: 11px;
    line-height: 22px;
    text-align: center;
    color: #ff7919;
    padding: 0;
    margin-left: 20px;
  }
  /deep/span {
    font-size: 12px;
    color: #999999;
    margin-left: 20px;
    cursor: pointer;
  }
  /deep/.right-menu {
    margin-left: 20px;
    /deep/.avatar-wrapper{
      margin-top: 0;
      padding-top: 20px;
    }
  }
}
</style>